import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Institution } from 'src/app/shared/models/institution';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class InstitutionService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}


	getInstitution(): Observable<Institution> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.institutionUrl}/get`,
			'getInstitution'
		);
	}

	updateInstitution(institution: Institution): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.institutionUrl}/update/${institution.id}`,
			'updateInstitution',
			institution
		);
	}

	downloadActivityReport(typeExport: string, serviceId: number, regionId: number, typeHandicapId: number, institution: Institution, 
		imgSrcList: string[]): Observable<Blob> {
		const payload = {
			typeExport: typeExport,
			serviceId: serviceId,
			regionId: regionId,
			typeHandicapId: typeHandicapId,
			dateDebut: institution.dateDebut,
			dateFin: institution.dateFin,
			imgSrcList: imgSrcList
		};
		console.log(payload);
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.institutionUrl}/downloadActivityReport`,
			'downloadActivityReport',
			payload,
			{
				responseType:'blob',
			}
		);
	}

	downloadReport(serviceId: number, regionId: number, institution: Institution): Observable<Blob> {
		const params = new HttpParams()
		.set('serviceId', serviceId)
		.set('regionId', regionId)
		.set('dateDebut', institution.dateDebut)
		.set('dateFin', institution.dateFin);
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.institutionUrl}/downloadReport/${serviceId}/${regionId}/${institution.dateDebut}/${institution.dateFin}`,
			'downloadExportBenef',
			{
				responseType:'blob'
			}
		);
	}

	downloadLastSynthesis(serviceId: number, regionId: number, dateDebut: string, dateFin: string): Observable<Blob> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.institutionUrl}/downloadSynthesisBdc/${serviceId}/${regionId}/${dateDebut}/${dateFin}`,
			'downloadSynthesisBdc',
			{
				responseType:'blob'
			}
		);
	}

	downloadSynthesisByBdc(bdcId: number): Observable<Blob> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.institutionUrl}/downloadSynthesisByBdc/${bdcId}`,
			'downloadSynthesisByBdc',
			{
				responseType:'blob'
			}
		);
	}

	updateBdcTrackHours(): Observable<Institution> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.institutionUrl}/updateBdcTrackHours`,
			'updateBdcTrackHours'
		);
	}

	generateAndAddToGedSynthesisBdc(): Observable<Institution> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.institutionUrl}/generateAndAddToGedSynthesisBdc`,
			'generateAndAddToGedSynthesisBdc'
		);
	}

	updateServer(): Observable<Institution> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.institutionUrl}/updateServer`,
			'updateServer'
		);
	}
}

